module.exports = __webpack_public_path__ + "static/assets/25dc16e8afde55e7cd0ca1757222aa69.gif";